module.exports = __webpack_public_path__ + "mobile/img/icon_home_nav_logo4.99047020.png";